import styled from 'styled-components';

export const Lista = styled.div`
  table {
    font-size: 1.1rem;
    width: 100%;
  }

  table,
  th,
  td {
    border: 0;
  }

  th {
    text-align: left;
    font-size: 1.3rem;
  }

  td {
    padding: 1rem;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
`;
